export const COMPANY_INFO = {
  name: 'Maplio',
  email: 'info@maplio.com.tr',
  phoneDisplay: '0532 179 93 21',
  phoneTel: '+905321799321',
  address: 'Esentepe Mh. Kasap Sk. Özen Apt. No:15 K:4 D:11, Şht. Ertuğrul Kabataş Cd., 34394 Şişli/İstanbul',
};

export const LEGAL_LAST_UPDATED = '08.03.2026';
